import React, { useState, useContext } from "react";
import ReadingYourMeterContextProvider, {
    ReadingYourMeterContext,
    ACTIONS
} from "../../context/ReadingYourMeterProvider";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import "../../styles/aporteDeLectura.scss"
import { useModal } from "@clayui/modal";
import { CGE } from "../../../../common/components/CGE";
import { decode_utf8, transformId } from "../../../../common/utils/utilsFunc";
import { Formik } from 'formik';
import Loading from "../../../../common/components/Loading";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const ReadingYourMeter = ({props}) => {
    const [state, dispatch] = useContext(ReadingYourMeterContext)
    const [qtdDigMed, setQtdDigMed] = useState('N');
    const [deliAddress, setDeliAddress] = useState("");
    const [fareType, setFareType] = useState("");
    const [comuna, setComuna] = useState("");
    const [numCli, setNumCli] = useState("");
    const [loading, setLoading] = React.useState(false)
    const properties = useContext(ApplicationPropertiesContext);
    const [verifReCaptcha, setVerifReCaptcha] = useState(false);
    const [ConfirmacionCheckbox, setConfirmacionCheckbox] = useState(false);
    const [TerminosCheckbox, setTerminosCheckbox] = useState(false);
    const [emptyInput, setEmptyInput] = useState(false);
    const [inputClientPublic, setInputClientPublic] = React.useState('')
    const [clickForm, setClickForm] = useState(false);
    const [validatedInput, setValidatedInput] = useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([])
    const [togggleResetForms, setToggleResetForm] = React.useState(false)
    const [values2, setValues] = React.useState([])
    const [handleClient, setHandleClient] = useState(false)
    const [visibleModal2, setVisibleModal2] = useState(false);
    const [visibleModal, setVisibleModal] = useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModal2(false);
        },
    });
    const [errorsForm, setErrorsForm] = React.useState({});
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }
    let propsLabelInfoContentMedidor = {
        "content": state?.webContentMedidor,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal2,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal2,
        "titleHint": "Cómo ingresar lectura?",
    }

    let readingDate
    let data = new Date();
    let day = String(data.getDate()).padStart(2, '0');
    let month = String(data.getMonth() + 1).padStart(2, '0');
    let year = data.getFullYear();
    readingDate = day + '/' + month + '/' + year;

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClickForm() {
        setClickForm(true);
    }

    function handleClickClient(numCli) {
        if(numCli) {
            setLoading(true);
            dispatch({
                payload: numCli,
                type: ACTIONS.SET_CTA_CTO,
            })
            setHandleClient(false)
        } else {
            setHandleClient(true)
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning")
        }
    }

    React.useEffect(() => {
        if(state.detailClient){
          setLoading(false)
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
                setDetailClientJson([])
                if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN !== 0 && state.detailClient.status !== 500){
                    props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
                }
            }
          } else {
            setDetailClientJson([])
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient])

    React.useEffect(() => {

        const ObjResponse = state.response_serv1;
        setLoading(false);

        if(ObjResponse) {
            if(ObjResponse?.code === 0) {
                setQtdDigMed(ObjResponse?.cantidadDigitosMedidor);
                setDeliAddress(ObjResponse?.direccion);
                setFareType(ObjResponse?.tipoTarifa);
                setComuna(ObjResponse?.comuna);
            } else {
                if(ObjResponse?.message){
                    props.setGlobalAlert(ObjResponse?.message, "info", true, "Información");
                    setInputClientPublic("");
                    setDetailClientJson([]);
                } else {
                    props.setGlobalAlert(props.text_fetch_error, "warning", true, "Advertencia");
                }
            }
        }
        
    },[state.response_serv1])

    React.useEffect(() => {
        if(togggleResetForms){
            setInputClientPublic("")
            setValues({
                CuentaContrato: '',
                DeliveryAddress: '',
                MeterReading: '',
                FullName: '',
                Email: '',
                Observacion: '',
            })
            setConfirmacionCheckbox(false);
            setTerminosCheckbox(false);
            setToggleResetForm(false);
            
        }
    }, [togggleResetForms])

    React.useEffect(() => {

        const objResponse = state.response_serv2;
        setLoading(false);

        if(objResponse) {
            if(objResponse?.code === 0) {
                setDetailClientJson([]);
                setToggleResetForm(true);
                props.setGlobalAlert(objResponse?.message, objResponse?.tipoMessage, true, "Atención");
            } else {
                props.setGlobalAlert(objResponse?.message && objResponse?.status !== 500 ? objResponse?.message : props.text_fetch_error, "warning", true, "Advertencia");
            }
        }
        
    },[state.response_serv2]);


    return (
        <Formik
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            initialValues={{
                CuentaContrato: '',
                DeliveryAddress: '',
                MeterReading: '',
                FullName: '',
                Email: '',
                Observacion: '',
                ConfirmacionCheckbox: "N",
                TerminosCheckbox: "N",
            }}

            validate={values => {
                let errors = {
                    empty: {},
                    msg: {},
                    validated: {}
                };

                if (!values.CuentaContrato) {
                    errors.empty.CuentaContrato = true;
                    errors.msg.CuentaContrato  = "Debes ingresar el número de cliente.";
                } else {
                    setNumCli(values.CuentaContrato);
                }

                if (!values.MeterReading) {
                    errors.empty.MeterReading = true;
                    errors.msg.MeterReading  = "Debes ingresar la lectura del medidor.";
                }

                if (!values.FullName) {
                    errors.empty.FullName = true;
                    errors.msg.FullName  = "Debes ingresar un nombre para datos de contacto.";
                }

                if (!values.Email) {
                    errors.empty.Email = true;
                    errors.msg.Email  = "Debes ingresar un correo electrónico para datos de contacto.";
                }

                if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.Email)) {
                    errors.validated.Email = true;
                    errors.msg.Email  = "Debes ingresar un correo electrónico válido.";
                }

                if (Object.keys(errors?.empty)?.length > 0) {
                    setEmptyInput(true);
                } else {
                    setEmptyInput(false);
                }

                if (Object.keys(errors?.validated)?.length > 0) {
                    setValidatedInput(true);
                } else {
                    setValidatedInput(false);
                }

                if (Object.keys(errors?.validated)?.length === 0 && Object.keys(errors?.empty)?.length === 0) {
                    errors = {};
                }

                setErrorsForm(errors);
            }}

            onSubmit={(values, { setSubmitting,resetForm },errors) => {
                if(clickForm) {
                    if(errorsForm.msg && Object.keys(errorsForm?.msg)?.length > 0 ) {
                        props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
                    } else if (transformId(state.ctaCtoAux) !== transformId(values.CuentaContrato) ) {
                        props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
                    }else if(!TerminosCheckbox) {
                        props.setGlobalAlert("Debes aceptar los términos y condiciones.", "warning");
                    }else if(!verifReCaptcha) {
                        props.setGlobalAlert("Falta validar que no eres un robot.", "warning");
                    }else {
                        setLoading(true);
                        dispatch({
                            payload: {values:values,qtdDigMed:qtdDigMed,deliAddress:deliAddress,fareType:fareType,readingDate:readingDate,comuna:comuna},
                            type: ACTIONS.SET_DATA_FORM,
                        })
                    }
                    setClickForm(false);
                }
            }}

        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <CGE.Panel title={decode_utf8(props.title_contribution_reading)}>
                    <form onSubmit={handleSubmit}>
                        <CGE.Spacing type="md" />
                        <CGE.PanelSection
                            title={decode_utf8(props.title_section_client)}

                        >
                            <div class="row">
                                <div className="col-md-12">
                                    <CGE.DetailClient
                                        props={{
                                            handleChange: (event) => {
                                                handleChange(event)
                                                setInputClientPublic(event.target.value)

                                            },
                                            hasError: errorsForm?.empty?.CuentaContrato || handleClient,
                                            msgError: "Debes ingresar el número de cliente.",
                                            idClient: inputClientPublic,
                                            idFormElement: "numberClientId",
                                            labelName: "Número de Cliente:",
                                            placeholder: "Número de Cliente",
                                            propsLabelInfoContent:propsLabelInfoContent,
                                            mandatoryElement: true,
                                            valuePub: values.CuentaContrato = inputClientPublic,
                                            labelButton: "Buscar",
                                            handleClick: () => { handleClickClient(values.CuentaContrato) },
                                            sizeButton: "sm",
                                            typeButton: "primary",
                                            versionButton:"button",

                                        }}
                                        propsDetail={{
                                            fullNameClient: (detailClientJson?.PRIMER_NOMBRE_PERSONA || detailClientJson?.SEGUNDO_NOMBRE_PERSONA
                                                || detailClientJson?.APELLIDO_PERSONA) ? values.socialReason = `${detailClientJson?.PRIMER_NOMBRE_PERSONA} 
                                                ${detailClientJson?.SEGUNDO_NOMBRE_PERSONA} ${detailClientJson?.APELLIDO_PERSONA}` : "",
                                            comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                                            calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                                            nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                                            dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                                            ${detailClientJson?.PISO}` : "",
                                            ctaCtoClient: detailClientJson?.CTA_CTO
                                        }}
                                    />
                                </div>
                            </div>
                        </CGE.PanelSection>
                        <CGE.PanelSection
                            title={`${decode_utf8(props.subtitle3_contribution_reading)} ${qtdDigMed} dígitos:`}
                        >
                            <div className="row">
                                <div className="col-md-6">
                                    <CGE.FormsField
                                        disabled
                                        handleChange={(event) => {
                                            handleChange(event)
                                            setValues({...values, ReadingDate: event.target.value})

                                        }}
                                        idFormElement="ReadingDate"
                                        labelName="Fecha de Lectura:"
                                        typeElement="input"
                                        typeFormElement="text"
                                        value={readingDate}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <CGE.FormsField
                                        handleChange={(event) => {
                                            handleChange(event)
                                            setValues({...values, MeterReading: event.target.value})

                                        }}
                                        hasError={errorsForm?.empty?.MeterReading}
                                        msgError="Debes ingresar la lectura del medidor."
                                        idFormElement="MeterReading"
                                        labelName="Lectura del Medidor:"
                                        mandatoryElement={true}
                                        propsLabelInfoContent={propsLabelInfoContentMedidor}
                                        placeholder="1234567890"
                                        typeFormElement="text"
                                        typeElement="input-mask"
                                        maxLength="12"
                                        formatChars={{
                                            9: "[0-9]"
                                        }}
                                        mask="999999999999"
                                        value={values2.MeterReading}
                                    />
                                </div>
                                <div className="col-md-12 px-0">
                                    <CGE.Text
                                        size="4"
                                        text="Envianos tu Lectura:"
                                    />
                                    <CGE.Text
                                        size="1"
                                        text={decode_utf8(props.subtitle4_contribution_reading)}
                                    />
                                </div>
                                <div className="col-md-12 px-0">
                                    <CGE.FormsField
                                        handleChange={(event) => {
                                            handleChange(event)
                                            setValues({...values, Observacion: event.target.value})

                                        }}
                                        idFormElement="Observacion"
                                        labelName="Observación:"
                                        maxLength="1000"
                                        numberOfRows="3"
                                        placeholder="Si se requiere, déjanos aquí, alguna nota u observación"
                                        typeElement="textarea"
                                        value={values2.Observacion}
                                    />
                                    <CGE.Text
                                        infoLabel={true}
                                        size="2"
                                        text={
                                            <>
                                                Quedan {1000 - values.Observacion.length} caracteres
                                            </>
                                        }
                                    />
                                    <CGE.Spacing type="mg" />
                                </div>
                            </div>
                        </CGE.PanelSection>
                                        
                        <CGE.PanelSection title={decode_utf8(props.subtitle5_contribution_reading)}>
                            <div className="row">
                                <div className="col-md-12">

                                </div>
                                <div className="col-md-6">
                                    <CGE.FormsField
                                        hasError={errorsForm?.empty?.FullName}
                                        msgError="Debes ingresar un nombre para datos de contacto."
                                        handleChange={(event) => {
                                            handleChange(event)
                                            setValues({...values, FullName: event.target.value})

                                        }}
                                        idFormElement="FullName"
                                        labelName="Nombre Completo:"
                                        mandatoryElement={true}
                                        maxLength="100"
                                        placeholder="Nombre Completo"
                                        typeElement="input"
                                        typeFormElement="text"
                                        value={values2.FullName}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <CGE.FormsField
                                        handleChange={(event) => {
                                            handleChange(event)
                                            setValues({...values, Email: event.target.value})

                                        }}
                                        hasError={(errorsForm?.validated?.Email) || (errorsForm?.empty?.Email)}
                                        msgError=
                                        {
                                            errorsForm?.empty?.Email
                                                ? "Debes ingresar un correo electrónico para datos de contacto."
                                                : "Debes ingresar un correo electrónico válido."
                                        }
                                        idFormElement="Email"
                                        labelName="Correo Electrónico:"
                                        mandatoryElement={true}
                                        typeElement="input"
                                        typeFormElement="text"
                                        maxLength="100"
                                        placeholder="Correo Electrónico"
                                        value={values2.Email}
                                    />
                                </div>
                                <div className="col-md-12 px-0">
                                    <CGE.CheckBoxGroup
                                        labelNameCheckBoxGroup="Confirmación:"
                                        optionsGroup={[{
                                            "checked": ConfirmacionCheckbox,
                                            "handleChange": () => setConfirmacionCheckbox((val) => !val),
                                            "idFormElement": "ConfirmacionCheckbox",
                                            "labelName": "Suscribo a boleta electrónica",
                                            "typeElement": "input",
                                            "typeFormElement": "checkbox",
                                            "value": ConfirmacionCheckbox ? values.ConfirmacionCheckbox = "Y" : values.ConfirmacionCheckbox = "N",
                                        },
                                        ]}
                                    />
                                </div>
                            </div>
                        </CGE.PanelSection>
                        <CGE.PanelSection
                        title={decode_utf8(props.title_section_terminos_convenio_vulnerable)}>
                            <div className="col-md-12 px-0">
                                <CGE.RenderContent textContent={state?.webContentTermCond} />
                            </div>
                            <div className="col-md-12 px-0">
                                <CGE.CheckBoxGroup
                                    optionsGroup={[{
                                        "checked": TerminosCheckbox,
                                        "handleChange": () => setTerminosCheckbox((val) => !val),
                                        "idFormElement": "TerminosCheckbox",
                                        "labelName": "Acepto los Términos y Condiciones",
                                        "typeElement": "input",
                                        "typeFormElement": "checkbox",
                                        "mandatoryElement": "true",
                                        "value": TerminosCheckbox ? values.TerminosCheckbox = "Y" : values.TerminosCheckbox = "N",
                                    },
                                    ]}
                                />
                            </div>
                            <div className="col-md-12 px-0">
                                <CGE.FieldRecaptcha
                                    onChange={onChangeReCaptcha}
                                    sitekey={properties.api_key_recaptcha}
                                />
                            </div>
                        </CGE.PanelSection>
                        <div className="d-flex flex-row-reverse mr-0">
                            <CGE.Button
                                label="Enviar"
                                type="primary"
                                onClick={handleClickForm}
                                typeButton="submit"
                            />
                        </div>
                    </form>
                    {loading &&
                        <Loading />
                    }
                </CGE.Panel>
            )}
        </Formik>
    );
};

const ReadingYourMeterWithProvider = ({ props }) => (
    <ReadingYourMeterContextProvider>
        <ReadingYourMeter props={props} />
    </ReadingYourMeterContextProvider>
);
export default ReadingYourMeterWithProvider;
